import { Injectable } from "@angular/core";
import { CanActivate, CanActivateChild } from "@angular/router";
import { Store } from "@ngrx/store";
import { ZhhSessionLimitConfigService } from "@obg/ngx.common";
import { AuthSelector, CoreState } from "@obg/ngx.core";
import { combineLatest, Observable, of } from "rxjs";
import { switchMap } from "rxjs/operators";

import { ZhhSessionLimitGuardService } from "./zhh-session-limit-guard.service";

@Injectable({ providedIn: "root" })
export class ZhhSessionLimitGuard implements CanActivateChild, CanActivate {
	constructor(
		private store: Store<CoreState>,
		private sessionLimitGuardService: ZhhSessionLimitGuardService,
		private configService: ZhhSessionLimitConfigService
	) {}

	canActivate(): Observable<boolean> {
		return combineLatest([this.store.select(AuthSelector.isAuthenticated)]).pipe(
			switchMap(([isAuth]) => {
				if (!isAuth || !this.configService.isCzechiaGameplayBlockEnabled()) {
					return of(true);
				}

				return this.sessionLimitGuardService.isAccessAllowed$();
			})
		);
	}

	canActivateChild(): Observable<boolean> {
		return this.canActivate();
	}
}
